import { render, staticRenderFns } from "./pageTemplate.vue?vue&type=template&id=b09921cc"
import script from "./pageTemplate.vue?vue&type=script&lang=js"
export * from "./pageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports